module.exports = __webpack_public_path__ + "static/media/hcp-levels-table.d5d3a343.svg";